module.exports = __webpack_public_path__ + "img/t-c6.eeaf12ad.jpg";